import { render, staticRenderFns } from "./StickerPay.vue?vue&type=template&id=a5ac7b60&scoped=true&"
import script from "./StickerPay.vue?vue&type=script&lang=ts&"
export * from "./StickerPay.vue?vue&type=script&lang=ts&"
import style0 from "./StickerPay.vue?vue&type=style&index=0&id=a5ac7b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac7b60",
  null
  
)

export default component.exports